import React from "react";

import ErrorSVG from "assets/img/error.svg";

import styles from "./DiscountErrorModalContent.module.scss";

const DiscountErrorModalContent = ({ code, message, onDismiss }) => {
  const title = message || "The discount code you entered is not valid.";
  const body = message
    ? "Please update your code and try again, or continue without a discount."
    : "Please check you haven't mistyped it. Some codes expire after a time, so it may no longer be valid.";

  return (
    <div className={`modal-body ${styles.container}`}>
      <img alt="There's been an error with your discount code" src={ErrorSVG} />
      <h3 className={`gkit-h3 ${styles.title}`}>{title}</h3>
      {code && <p className={`gkit-p-17 ${styles.code}`}>{code}</p>}
      <p className={`gkit-p-15 ${styles.body}`}>{body}</p>

      <button
        className={`gkit-btn-md gkit-primary ${styles.button}`}
        onClick={onDismiss}
        type="button"
      >
        Continue
      </button>
    </div>
  );
};

export default DiscountErrorModalContent;
